export default __webpack_public_path__ + "static/NEVERENDINGPEPE-d6a090aa6123b0c9225fd0daabcd2a43.png";